import gql from 'graphql-tag';

import postFragment from '~/shared/graphql-queries/posts/post-fragment';

export default gql`
  mutation createOnePostMutation($record: CreateOnePostInput!) {
    createOnePostMutation(record: $record) {
      recordId
      record {
        ...PostFragment
      }
      message
      title
    }
  }
  ${postFragment}
`;
